import type { Router } from "../pages/Router";

export function bindBottomNav(buttons: HTMLButtonElement[], router: Router): void {
  for (const btn of buttons) {
    btn.addEventListener("click", () => {
      const path = btn.dataset["route"];
      if (!path) return;
      router.go(path);
    });
  }
}
